import React, { useState, useEffect } from 'react';
import PlayerService from '../../services/PlayerService';

const Leaderboard = ({ onClose }) => {
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlayers = async () => {
      const data = await PlayerService.getAllPlayers();
      setPlayers(data);
      setLoading(false);
    };
    fetchPlayers();
  }, []);

  if (loading) {
    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
        fontFamily: 'IBM BIOS, monospace'
      }}>
        <div style={{
          color: '#33ff33',
          textShadow: '0 0 8px #33ff33',
          animation: 'dataFlicker 1s infinite',
          fontSize: '18px',
          fontFamily: 'IBM BIOS, monospace',
          letterSpacing: '2px',
          padding: '40px'
        }}>
          SCANNING QUANTUM NETWORK...
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(2px)',
          WebkitBackdropFilter: 'blur(2px)',
          zIndex: 9998,
          animation: 'fadeIn 0.2s ease-out'
        }}
      />

      {/* Leaderboard Panel */}
      <div style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        maxWidth: '600px',
        maxHeight: '80vh',
        background: 'rgba(0, 0, 0, 0.95)',
        border: '2px solid #33ff33',
        boxShadow: '0 0 30px rgba(51, 255, 51, 0.3)',
        zIndex: 9999,
        color: '#33ff33',
        fontFamily: 'IBM BIOS, monospace',
        animation: 'pulse 2s infinite ease-in-out',
        backgroundImage: `
          linear-gradient(0deg, rgba(51, 255, 51, 0.05) 1px, transparent 1px),
          linear-gradient(90deg, rgba(51, 255, 51, 0.05) 1px, transparent 1px)
        `,
        backgroundSize: '20px 20px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)'
      }}>
        {/* Player List */}
        <div style={{
          flex: 1,
          overflowY: 'auto',
          padding: '24px',
          paddingTop: '16px'
        }}>
          {players.map((player, index) => (
            <div
              key={player.id}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '16px 20px',
                marginBottom: '12px',
                background: index === 0 ? 'rgba(51, 255, 51, 0.1)' : 'rgba(51, 255, 51, 0.05)',
                border: '1px solid rgba(51, 255, 51, 0.5)',
                borderRadius: '4px',
                transition: 'all 0.3s ease',
                fontFamily: 'IBM BIOS, monospace',
                position: 'relative',
                overflow: 'hidden',
                animation: `borderGlow 2s infinite ease-in-out ${index * 0.2}s`,
                cursor: 'pointer'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = 'rgba(51, 255, 51, 0.15)';
                e.currentTarget.style.transform = 'translateX(4px)';
                e.currentTarget.style.boxShadow = '0 0 15px rgba(51, 255, 51, 0.2)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = index === 0 ? 'rgba(51, 255, 51, 0.1)' : 'rgba(51, 255, 51, 0.05)';
                e.currentTarget.style.transform = 'translateX(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '2px',
                background: 'linear-gradient(90deg, transparent, #33ff33, transparent)',
                animation: `dataFlicker 3s infinite ${index * 0.1}s`
              }} />
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                flex: 1,
                minWidth: 0
              }}>
                <span style={{
                  opacity: 0.7,
                  width: '30px',
                  flexShrink: 0
                }}>
                  #{index + 1}
                </span>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: '4px',
                  flex: 1,
                  minWidth: 0
                }}>
                  <span style={{
                    textShadow: '0 0 8px #33ff33',
                    maxWidth: '100%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                  title={player.discordUsername}>
                    {player.discordUsername}
                  </span>
                  <span style={{
                    opacity: 0.7,
                    fontSize: '0.9em',
                    padding: '2px 8px',
                    border: '1px solid rgba(51, 255, 51, 0.3)',
                    background: 'rgba(51, 255, 51, 0.05)',
                    letterSpacing: '1px',
                    whiteSpace: 'nowrap',
                    flexShrink: 0
                  }}>
                    {player.rank ? `RANK ${player.rank}` : 'UNRANKED'}
                  </span>
                </div>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginLeft: '16px',
                flexShrink: 0,
                whiteSpace: 'nowrap'
              }}>
                <span style={{
                  textShadow: '0 0 8px #33ff33'
                }}>
                  {(player.qubits || 0).toLocaleString()}
                </span>
                <span style={{
                  opacity: 0.7,
                  fontSize: '0.9em'
                }}>
                  QUBITS
                </span>
              </div>
            </div>
          ))}
        </div>

        <style>
          {`
            @keyframes pulse {
              0% { box-shadow: 0 0 30px rgba(51, 255, 51, 0.3); }
              50% { box-shadow: 0 0 40px rgba(51, 255, 51, 0.4); }
              100% { box-shadow: 0 0 30px rgba(51, 255, 51, 0.3); }
            }
            @keyframes dataFlicker {
              0% { opacity: 1; }
              95% { opacity: 1; }
              96% { opacity: 0.8; }
              97% { opacity: 1; }
              98% { opacity: 0.9; }
              100% { opacity: 1; }
            }
            @keyframes borderGlow {
              0% { border-color: #33ff33; }
              50% { border-color: #66ff66; }
              100% { border-color: #33ff33; }
            }
            @keyframes fadeIn {
              from { opacity: 0; }
              to { opacity: 1; }
            }

            ::-webkit-scrollbar {
              width: 8px;
            }

            ::-webkit-scrollbar-track {
              background: rgba(51, 255, 51, 0.05);
            }

            ::-webkit-scrollbar-thumb {
              background: rgba(51, 255, 51, 0.3);
              border-radius: 4px;
            }

            ::-webkit-scrollbar-thumb:hover {
              background: rgba(51, 255, 51, 0.5);
            }
          `}
        </style>
      </div>
    </>
  );
};

export default Leaderboard;